import React from 'react';
import { Sidebar } from '@toqio/toqio-web-components'

import { useLogoImg } from 'utils/images';
import DynamicSideBar from './DynamicSideBar';


const SideBar = React.forwardRef((props: any) => {
  return (
    <Sidebar
      ref={props.forwardedRef}
      image={useLogoImg()}
    >
      {/* SIDEBAR ELEMENTS */}
      <DynamicSideBar sidebarRef={props.forwardedRef} />
    </Sidebar>
  )
})

export default SideBar;